import { AccordionItem, List, Strong, Text } from 'braid-design-system';

export const SectionH = () => (
  <AccordionItem id="section-h" label="Section H: Optimised Apply Solution">
    <List type="number" start={96}>
      <Text>
        Section H applies if you have chosen to use the Optimised Apply Solution
        functionality through the SEEK API.
      </Text>
      <Text>
        <Strong>Optimised Apply Solution</Strong> means the method used to
        distribute Candidate applications to Partners and Advertisers.
      </Text>
      <Text>
        You must ensure that the following Optimised Apply Solution
        functionality is enabled for Advertisers via the SEEK API at all times:
        retrieving and distributing Candidate applications to the Advertiser
        including all associated documents. Associated documents may include
        resumes, cover letters, Profiles, submission to questionnaires.
      </Text>
    </List>
  </AccordionItem>
);
